import React, { useState } from 'react';
import { buildGoogleAuthUrl, getGoogleClientId } from '../utils/googleAuth';

const THERAPIES = [
  // Breast Cancer
  { id: 1, label: 'Paclitaxel + Trastuzumab', cancer: 'Breast Cancer', stage: 'Stage II' },
  { id: 2, label: 'Tamoxifen', cancer: 'Breast Cancer', stage: 'Stage I-II' },
  { id: 3, label: 'Anastrozole', cancer: 'Breast Cancer', stage: 'Stage I-III' },
  { id: 4, label: 'Letrozole', cancer: 'Breast Cancer', stage: 'Stage I-III' },
  { id: 5, label: 'Fulvestrant', cancer: 'Breast Cancer', stage: 'Stage IV' },
  { id: 6, label: 'Palbociclib', cancer: 'Breast Cancer', stage: 'Stage IV' },

  // Colorectal Cancer
  { id: 7, label: 'FOLFOX', cancer: 'Colorectal Cancer', stage: 'Stage III' },
  { id: 8, label: 'Capecitabine', cancer: 'Colorectal Cancer', stage: 'Stage II-III' },
  { id: 9, label: 'Cetuximab', cancer: 'Colorectal Cancer', stage: 'Stage IV' },
  { id: 10, label: 'Bevacizumab', cancer: 'Colorectal Cancer', stage: 'Stage IV' },
  { id: 11, label: 'Regorafenib', cancer: 'Colorectal Cancer', stage: 'Stage IV' },

  // Lung Cancer
  { id: 12, label: 'Pembrolizumab', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 13, label: 'Osimertinib', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 14, label: 'Atezolizumab', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 15, label: 'Crizotinib', cancer: 'Lung Cancer', stage: 'Stage IV' },
  { id: 16, label: 'Docetaxel', cancer: 'Lung Cancer', stage: 'Stage III-IV' },

  // Prostate Cancer
  { id: 17, label: 'Docetaxel', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 18, label: 'Abiraterone', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 19, label: 'Enzalutamide', cancer: 'Prostate Cancer', stage: 'Stage IV' },
  { id: 20, label: 'Leuprolide', cancer: 'Prostate Cancer', stage: 'Stage II-IV' },

  // Pancreatic Cancer
  { id: 21, label: 'Gemcitabine', cancer: 'Pancreatic Cancer', stage: 'Stage II-IV' },
  { id: 22, label: 'FOLFIRINOX', cancer: 'Pancreatic Cancer', stage: 'Stage II-III' },
  { id: 23, label: 'Nab-paclitaxel', cancer: 'Pancreatic Cancer', stage: 'Stage IV' },

  // Ovarian Cancer
  { id: 24, label: 'Carboplatin + Paclitaxel', cancer: 'Ovarian Cancer', stage: 'Stage III-IV' },
  { id: 25, label: 'Bevacizumab', cancer: 'Ovarian Cancer', stage: 'Stage III-IV' },
  { id: 26, label: 'Olaparib', cancer: 'Ovarian Cancer', stage: 'Stage IV' },

  // Bladder Cancer
  { id: 27, label: 'Cisplatin + Gemcitabine', cancer: 'Bladder Cancer', stage: 'Stage IV' },
  { id: 28, label: 'Atezolizumab', cancer: 'Bladder Cancer', stage: 'Stage IV' },
  { id: 29, label: 'Pembrolizumab', cancer: 'Bladder Cancer', stage: 'Stage IV' },

  // Kidney Cancer
  { id: 30, label: 'Sunitinib', cancer: 'Kidney Cancer', stage: 'Stage IV' },
  { id: 31, label: 'Pazopanib', cancer: 'Kidney Cancer', stage: 'Stage IV' },
  { id: 32, label: 'Nivolumab', cancer: 'Kidney Cancer', stage: 'Stage IV' },

  // Liver Cancer
  { id: 33, label: 'Sorafenib', cancer: 'Liver Cancer', stage: 'Stage IV' },
  { id: 34, label: 'Lenvatinib', cancer: 'Liver Cancer', stage: 'Stage IV' },
  { id: 35, label: 'Atezolizumab + Bevacizumab', cancer: 'Liver Cancer', stage: 'Stage IV' },

  // Stomach Cancer
  { id: 36, label: 'Trastuzumab', cancer: 'Stomach Cancer', stage: 'Stage IV' },
  { id: 37, label: 'Ramucirumab', cancer: 'Stomach Cancer', stage: 'Stage IV' },
  { id: 38, label: 'FOLFOX', cancer: 'Stomach Cancer', stage: 'Stage II-III' },

  // Esophageal Cancer
  { id: 39, label: 'Cisplatin + Fluorouracil', cancer: 'Esophageal Cancer', stage: 'Stage II-III' },
  { id: 40, label: 'Docetaxel', cancer: 'Esophageal Cancer', stage: 'Stage IV' },

  // Head and Neck Cancer
  { id: 41, label: 'Cisplatin', cancer: 'Head and Neck Cancer', stage: 'Stage III-IV' },
  { id: 42, label: 'Cetuximab', cancer: 'Head and Neck Cancer', stage: 'Stage III-IV' },
  { id: 43, label: 'Pembrolizumab', cancer: 'Head and Neck Cancer', stage: 'Stage IV' },

  // Melanoma
  { id: 44, label: 'Dabrafenib + Trametinib', cancer: 'Melanoma', stage: 'Stage IV' },
  { id: 45, label: 'Nivolumab', cancer: 'Melanoma', stage: 'Stage IV' },
  { id: 46, label: 'Ipilimumab', cancer: 'Melanoma', stage: 'Stage IV' },

  // Leukemia
  { id: 47, label: 'Imatinib', cancer: 'Chronic Myeloid Leukemia', stage: 'All Stages' },
  { id: 48, label: 'Dasatinib', cancer: 'Chronic Myeloid Leukemia', stage: 'All Stages' },
  { id: 49, label: 'Venetoclax', cancer: 'Acute Myeloid Leukemia', stage: 'All Stages' },

  // Lymphoma
  { id: 50, label: 'Rituximab + CHOP', cancer: 'Non-Hodgkin Lymphoma', stage: 'Stage III-IV' },
  { id: 51, label: 'Brentuximab', cancer: 'Hodgkin Lymphoma', stage: 'Stage III-IV' },
  { id: 52, label: 'Ibrutinib', cancer: 'Non-Hodgkin Lymphoma', stage: 'Stage IV' },

  // Multiple Myeloma
  { id: 53, label: 'Bortezomib', cancer: 'Multiple Myeloma', stage: 'All Stages' },
  { id: 54, label: 'Lenalidomide', cancer: 'Multiple Myeloma', stage: 'All Stages' },
  { id: 55, label: 'Daratumumab', cancer: 'Multiple Myeloma', stage: 'All Stages' },

  // Thyroid Cancer
  { id: 56, label: 'Sorafenib', cancer: 'Thyroid Cancer', stage: 'Stage IV' },
  { id: 57, label: 'Lenvatinib', cancer: 'Thyroid Cancer', stage: 'Stage IV' },

  // Brain Cancer
  { id: 58, label: 'Temozolomide', cancer: 'Glioblastoma', stage: 'Stage IV' },
  { id: 59, label: 'Bevacizumab', cancer: 'Glioblastoma', stage: 'Stage IV' },

  // Cervical Cancer
  { id: 60, label: 'Cisplatin', cancer: 'Cervical Cancer', stage: 'Stage II-IV' },
  { id: 61, label: 'Bevacizumab', cancer: 'Cervical Cancer', stage: 'Stage IV' },

  // Endometrial Cancer
  { id: 62, label: 'Carboplatin + Paclitaxel', cancer: 'Endometrial Cancer', stage: 'Stage III-IV' },
  { id: 63, label: 'Pembrolizumab', cancer: 'Endometrial Cancer', stage: 'Stage IV' },
];

const CANCER_TYPES = [
  'Acute Myeloid Leukemia',
  'Bladder Cancer',
  'Brain Cancer',
  'Breast Cancer',
  'Cervical Cancer',
  'Chronic Myeloid Leukemia',
  'Colorectal Cancer',
  'Endometrial Cancer',
  'Esophageal Cancer',
  'Glioblastoma',
  'Head and Neck Cancer',
  'Hodgkin Lymphoma',
  'Kidney Cancer',
  'Liver Cancer',
  'Lung Cancer',
  'Melanoma',
  'Multiple Myeloma',
  'Non-Hodgkin Lymphoma',
  'Ovarian Cancer',
  'Pancreatic Cancer',
  'Prostate Cancer',
  'Stomach Cancer',
  'Thyroid Cancer',
];

const DISEASE_STAGES = ['Stage I', 'Stage I-II', 'Stage II', 'Stage II-III', 'Stage III', 'Stage IV', 'All Stages'];

const USER_ROLES = [
  { id: 'patient', label: 'Patient', description: 'I have or had cancer' },
  { id: 'caregiver', label: 'Caregiver', description: 'I care for someone with cancer' },
  { id: 'medical_professional', label: 'Medical Professional', description: 'Healthcare provider' },
  { id: 'exploring', label: 'Exploring', description: 'Learning about cancer' },
];

const CURRENT_SITUATIONS = [
  { id: 'waiting_diagnosis', label: 'Waiting for Diagnosis', description: 'Suspected cancer, awaiting confirmation' },
  { id: 'just_diagnosed', label: 'Just Diagnosed', description: 'Recently diagnosed with cancer' },
  { id: 'in_treatment', label: 'In Treatment', description: 'Currently receiving cancer treatment' },
  { id: 'no_evidence', label: 'No Evidence of Disease', description: 'Completed treatment, in remission' },
];

const ONTARIO_CANCER_CENTERS = [
  'Windsor Regional Cancer Centre',
  'Verspeeten Family Cancer Centre',
  'Waterloo Regional Health Network Cancer Centre',
  'Juravinski Cancer Centre',
  'Carlo Fidani Regional Cancer Centre',
  'Odette Cancer Centre',
  'Princess Margaret Cancer Centre',
  'Stronach Regional Cancer Centre at Southlake',
  'R.S. McLaughlin Durham Regional Cancer Centre',
  'Cancer Centre of Southeastern Ontario',
  'The Ottawa Hospital Cancer Centre',
  'Simcoe Muskoka Regional Cancer Centre',
  'Northeast Cancer Centre',
  'Regional Cancer Care Northwest',
];

export default function Login({ onLogin }) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [registrationStep, setRegistrationStep] = useState('account'); // 'account', 'role', 'cancer_center', 'situation', 'cancer', 'stage', 'therapies'
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    name: '',
    dateOfBirth: '',
    email: '',
    role: '',
    cancerCenter: '',
    currentSituation: '',
    cancerType: '',
    diseaseStage: '',
    selectedTherapies: [],
  });
  const [cancerSearch, setCancerSearch] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotType, setForgotType] = useState('password'); // 'password' or 'username'
  const [resetStep, setResetStep] = useState('request'); // 'request' or 'confirm' for password flow
  const [resetEmail, setResetEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTherapyToggle = (therapyId) => {
    setFormData((prev) => ({
      ...prev,
      selectedTherapies: prev.selectedTherapies.includes(therapyId)
        ? prev.selectedTherapies.filter((id) => id !== therapyId)
        : [...prev.selectedTherapies, therapyId]
    }));
  };

  const handleNext = () => {
    if (registrationStep === 'account') {
      if (!formData.username || !formData.password || !formData.name || !formData.dateOfBirth || !formData.email) {
        setError('All fields are required');
        return;
      }
      if (formData.username.length < 3) {
        setError('Username must be at least 3 characters');
        return;
      }
      if (formData.password.length < 6) {
        setError('Password must be at least 6 characters');
        return;
      }
      setError('');
      setRegistrationStep('role');
    } else if (registrationStep === 'role') {
      if (!formData.role) {
        setError('Please select your role');
        return;
      }
      setError('');
      if (formData.role === 'medical_professional' || formData.role === 'patient') {
        setRegistrationStep('cancer_center');
        return;
      }
      setRegistrationStep('situation');
    } else if (registrationStep === 'cancer_center') {
      if (!formData.cancerCenter) {
        setError('Please select your cancer center');
        return;
      }
      setError('');
      handleSubmit();
    } else if (registrationStep === 'situation') {
      if (!formData.currentSituation) {
        setError('Please select your current situation');
        return;
      }
      setError('');
      setRegistrationStep('cancer');
    } else if (registrationStep === 'cancer') {
      if (!formData.cancerType) {
        setError('Please select a cancer type');
        return;
      }
      setError('');
      setRegistrationStep('stage');
    } else if (registrationStep === 'stage') {
      if (!formData.diseaseStage) {
        setError('Please select a disease stage');
        return;
      }
      setError('');
      setRegistrationStep('therapies');
    } else if (registrationStep === 'therapies') {
      if (formData.selectedTherapies.length === 0) {
        setError('Please select at least one therapy');
        return;
      }
      setError('');
      handleSubmit();
    }
  };

  const handleBack = () => {
    if (registrationStep === 'therapies') setRegistrationStep('stage');
    else if (registrationStep === 'stage') setRegistrationStep('cancer');
    else if (registrationStep === 'cancer') setRegistrationStep('situation');
    else if (registrationStep === 'situation') setRegistrationStep('role');
    else if (registrationStep === 'cancer_center') setRegistrationStep('role');
    else if (registrationStep === 'role') setRegistrationStep('account');
    setError('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');

    try {
      const isMedicalProfessional = formData.role === 'medical_professional';
      const requiresCancerCenter = formData.role === 'medical_professional' || formData.role === 'patient';
      const therapyDetails = formData.selectedTherapies.map((id) =>
        THERAPIES.find((t) => t.id === id)
      );

      const currentSituation = isMedicalProfessional ? 'not_applicable' : formData.currentSituation;
      const cancerType = isMedicalProfessional ? 'not_applicable' : formData.cancerType;
      const diseaseStage = isMedicalProfessional ? 'not_applicable' : formData.diseaseStage;
      const therapies = isMedicalProfessional ? [] : therapyDetails;
      const cancerCenter = requiresCancerCenter ? formData.cancerCenter : null;

      const payload = {
        username: formData.username,
        password: formData.password,
        name: formData.name,
        dateOfBirth: formData.dateOfBirth,
        email: formData.email,
        role: formData.role,
        currentSituation,
        cancerType,
        diseaseStage,
        cancerCenter,
        therapies,
      };

      console.log('Registration request:', payload);

      const res = await fetch(`https://toxsee.onrender.com/api/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log('Registration response:', data);

      if (!res.ok) {
        setError(data.error || 'Registration failed');
        setLoading(false);
        return;
      }

      // Store user info and auth token
      const user = data.user;
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('userProfile', JSON.stringify({
        role: formData.role,
        currentSituation,
        cancerType,
        diseaseStage,
        cancerCenter,
        therapies,
      }));

      // Call the onLogin callback
      onLogin(user);
    } catch (err) {
      console.error('Registration error:', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const payload = { username: formData.username, password: formData.password };

      console.log('Login request:', payload);

      const res = await fetch(`https://toxsee.onrender.com/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log('Login response:', data);

      if (!res.ok) {
        setError(data.error || 'Login failed');
        setLoading(false);
        return;
      }

      // Store user info and auth token
      const user = data.user;
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(user));

      // Store profile if it exists
      if (data.profile) {
        localStorage.setItem('userProfile', JSON.stringify(data.profile));
      } else {
        localStorage.removeItem('userProfile');
      }

      // Call the onLogin callback
      onLogin(user);
    } catch (err) {
      console.error('Login error:', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    }
  };

  const handleGoogleSignIn = () => {
    const clientId = getGoogleClientId();
    if (!clientId) {
      setError('Google sign-in is not configured yet. Add your Google client ID to the frontend env file first.');
      return;
    }

    const googleUrl = buildGoogleAuthUrl();

    if (!googleUrl) {
      setError('Google sign-in could not be started.');
      return;
    }

    window.location.assign(googleUrl);
  };

  const handleRequestPasswordReset = async () => {
    setError('');
    setLoading(true);
    try {
      const email = resetEmail.trim();
      if (!email) {
        setError('Email is required for password reset');
        setLoading(false);
        return;
      }

      const res = await fetch('https://toxsee.onrender.com/api/request-password-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Failed to request reset code');
        setLoading(false);
        return;
      }

      setError('Reset code sent. Check your email (or console in dev).');
      setResetStep('confirm');
      setLoading(false);
    } catch (err) {
      console.error('Request password reset error:', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setError('');
    setLoading(true);
    try {
      const payload = {
        email: resetEmail.trim(),
        resetCode: resetCode.trim(),
        newPassword: newPassword.trim()
      };

      if (!payload.email || !payload.resetCode || !payload.newPassword) {
        setError('Email, code, and new password are required');
        setLoading(false);
        return;
      }
      if (payload.newPassword.length < 6) {
        setError('Password must be at least 6 characters');
        setLoading(false);
        return;
      }

      const res = await fetch('https://toxsee.onrender.com/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Password reset failed');
        setLoading(false);
        return;
      }

      setError('Password reset successful. Please sign in with your new password.');
      setForgotMode(false);
      setResetStep('request');
      setResetEmail('');
      setResetCode('');
      setNewPassword('');
      setLoading(false);
    } catch (err) {
      console.error('Reset password error:', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    }
  };

  const handleRequestUsername = async () => {
    setError('');
    setLoading(true);
    try {
      const email = resetEmail.trim();
      if (!email) {
        setError('Email is required for username recovery');
        setLoading(false);
        return;
      }

      const res = await fetch('https://toxsee.onrender.com/api/request-username', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Failed to request username recovery');
        setLoading(false);
        return;
      }

      setError('Username recovery sent to email (or logged to console in dev).');
      setLoading(false);
    } catch (err) {
      console.error('Request username error:', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    }
  };

  const filteredTherapies = THERAPIES.filter((t) => t.cancer === formData.cancerType);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--page-bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        padding: '40px',
        maxWidth: '500px',
        width: '100%',
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          marginBottom: '32px',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: 'var(--brand-primary-light)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
          }}>
            <img src="/logo192.png" alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '4px' }} />
          </div>
          <span style={{
            fontWeight: '700',
            fontSize: '24px',
            color: 'var(--teal)',
          }}>
            Reaxano
          </span>
        </div>

        {/* Progress (Registration Only) */}
        {isRegistering && (
          <div style={{
            display: 'flex',
            gap: '8px',
            marginBottom: '32px',
            justifyContent: 'center',
          }}>
            {['account', 'role', 'cancer_center', 'situation', 'cancer', 'stage', 'therapies'].map((s) => (
              <div
                key={s}
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  background: registrationStep === s ? 'var(--teal)' :
                    (s === 'account' && ['role', 'cancer_center', 'situation', 'cancer', 'stage', 'therapies'].includes(registrationStep)) ||
                    (s === 'role' && ['cancer_center', 'situation', 'cancer', 'stage', 'therapies'].includes(registrationStep)) ||
                    (s === 'cancer_center' && ['situation', 'cancer', 'stage', 'therapies'].includes(registrationStep)) ||
                    (s === 'situation' && ['cancer', 'stage', 'therapies'].includes(registrationStep)) ||
                    (s === 'cancer' && ['stage', 'therapies'].includes(registrationStep)) ||
                    (s === 'stage' && registrationStep === 'therapies') ? 'var(--teal)' : '#ddd',
                }}
              />
            ))}
          </div>
        )}

        {/* Title */}
        <h2 style={{
          marginBottom: '8px',
          fontSize: '22px',
          fontWeight: '600',
          color: '#1a1a1a',
        }}>
          {isRegistering ? 'Create Account' : 'Welcome'}
        </h2>
        <p style={{
          marginBottom: '28px',
          fontSize: '14px',
          color: '#666',
        }}>
          {isRegistering
            ? registrationStep === 'account' ? 'Enter your account details' 
              : registrationStep === 'role' ? 'Tell us about yourself'
              : registrationStep === 'cancer_center' ? 'Select your cancer center'
              : registrationStep === 'situation' ? 'What is your current situation?'
              : registrationStep === 'cancer' ? 'Which cancer are you learning about?'
              : registrationStep === 'stage' ? 'Select disease stage'
              : 'Select your therapies'
            : 'Sign in to your account'}
        </p>

        {/* Error Message */}
        {error && (
          <div style={{
            marginBottom: '16px',
            padding: '12px',
            background: '#FEE',
            border: '1px solid #FCC',
            borderRadius: '8px',
            color: '#C33',
            fontSize: '14px',
          }}>
            {error}
          </div>
        )}

        {/* Registration Form */}
        {isRegistering ? (
          <form onSubmit={(e) => e.preventDefault()}>
            {/* Step 1: Account Details */}
            {registrationStep === 'account' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '24px' }}>
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                    placeholder="Username"
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder="Password"
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Full Name"
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                  <input
                    type="date"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                    required
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Email"
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                </div>
                <button
                  onClick={handleNext}
                  style={{
                    width: '100%',
                    padding: '12px',
                    background: 'var(--teal)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                >
                  Next
                </button>
              </>
            )}

            {/* Step 2: Role Selection */}
            {registrationStep === 'role' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                  {USER_ROLES.map((role) => (
                    <button
                      key={role.id}
                      onClick={() => setFormData(prev => ({ ...prev, role: role.id }))}
                      style={{
                        padding: '16px',
                        textAlign: 'left',
                        borderRadius: '8px',
                        border: formData.role === role.id ? '2px solid var(--teal)' : '1px solid #ddd',
                        background: formData.role === role.id ? 'var(--brand-primary-light)' : 'white',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: '500',
                      }}
                    >
                      <div>
                        <div style={{ fontWeight: '600', color: '#1a1a1a' }}>
                          {role.label}
                        </div>
                        <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                          {role.description}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={handleBack}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'white',
                      color: 'var(--teal)',
                      border: '1px solid var(--teal)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNext}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'var(--teal)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {registrationStep === 'cancer_center' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                  {ONTARIO_CANCER_CENTERS.map((center) => (
                    <button
                      key={center}
                      onClick={() => setFormData(prev => ({ ...prev, cancerCenter: center }))}
                      style={{
                        padding: '16px',
                        textAlign: 'left',
                        borderRadius: '8px',
                        border: formData.cancerCenter === center ? '2px solid var(--teal)' : '1px solid #ddd',
                        background: formData.cancerCenter === center ? 'var(--brand-primary-light)' : 'white',
                        cursor: 'pointer',
                        fontSize: '15px',
                        fontWeight: '500',
                      }}
                    >
                      {center}
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={handleBack}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'white',
                      color: 'var(--teal)',
                      border: '1px solid var(--teal)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNext}
                    disabled={loading}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'var(--teal)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      opacity: loading ? 0.6 : 1,
                    }}
                  >
                    {loading ? 'Creating Account...' : 'Complete Setup'}
                  </button>
                </div>
              </>
            )}

            {/* Step 3: Current Situation */}
            {registrationStep === 'situation' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                  {CURRENT_SITUATIONS.map((situation) => (
                    <button
                      key={situation.id}
                      onClick={() => setFormData(prev => ({ ...prev, currentSituation: situation.id }))}
                      style={{
                        padding: '16px',
                        textAlign: 'left',
                        borderRadius: '8px',
                        border: formData.currentSituation === situation.id ? '2px solid var(--teal)' : '1px solid #ddd',
                        background: formData.currentSituation === situation.id ? 'var(--brand-primary-light)' : 'white',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: '500',
                      }}
                    >
                      <div>
                        <div style={{ fontWeight: '600', color: '#1a1a1a' }}>
                          {situation.label}
                        </div>
                        <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                          {situation.description}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={handleBack}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'white',
                      color: 'var(--teal)',
                      border: '1px solid var(--teal)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNext}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'var(--teal)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* Step 4: Cancer Type */}
            {registrationStep === 'cancer' && (
              <>
                <div style={{ marginBottom: '16px' }}>
                  <input
                    type="text"
                    value={cancerSearch}
                    onChange={(e) => setCancerSearch(e.target.value)}
                    placeholder="Search cancer types..."
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                      marginBottom: '12px',
                    }}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px', maxHeight: '300px', overflowY: 'auto' }}>
                  {CANCER_TYPES.filter(cancer => 
                    cancer.toLowerCase().includes(cancerSearch.toLowerCase())
                  ).map((cancer) => (
                    <button
                      key={cancer}
                      onClick={() => setFormData(prev => ({ ...prev, cancerType: cancer }))}
                      style={{
                        padding: '12px',
                        textAlign: 'left',
                        borderRadius: '8px',
                        border: formData.cancerType === cancer ? '2px solid var(--teal)' : '1px solid #ddd',
                        background: formData.cancerType === cancer ? 'var(--brand-primary-light)' : 'white',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                      }}
                    >
                      {cancer}
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={handleBack}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'white',
                      color: 'var(--teal)',
                      border: '1px solid var(--teal)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNext}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'var(--teal)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* Step 5: Disease Stage */}
            {registrationStep === 'stage' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                  {CANCER_TYPES.map((cancer) => (
                    <button
                      key={cancer}
                      onClick={() => setFormData(prev => ({ ...prev, cancerType: cancer }))}
                      style={{
                        padding: '16px',
                        textAlign: 'left',
                        borderRadius: '8px',
                        border: formData.cancerType === cancer ? '2px solid var(--teal)' : '1px solid #ddd',
                        background: formData.cancerType === cancer ? 'var(--brand-primary-light)' : 'white',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: '500',
                      }}
                    >
                      {cancer}
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={handleBack}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'white',
                      color: 'var(--teal)',
                      border: '1px solid var(--teal)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNext}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'var(--teal)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* Step 3: Disease Stage */}
            {registrationStep === 'stage' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                  {DISEASE_STAGES.map((stage) => (
                    <button
                      key={stage}
                      onClick={() => setFormData(prev => ({ ...prev, diseaseStage: stage }))}
                      style={{
                        padding: '16px',
                        textAlign: 'left',
                        borderRadius: '8px',
                        border: formData.diseaseStage === stage ? '2px solid var(--teal)' : '1px solid #ddd',
                        background: formData.diseaseStage === stage ? 'var(--brand-primary-light)' : 'white',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: '500',
                      }}
                    >
                      {stage}
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={handleBack}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'white',
                      color: 'var(--teal)',
                      border: '1px solid var(--teal)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNext}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'var(--teal)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* Step 4: Therapies */}
            {registrationStep === 'therapies' && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                  {filteredTherapies.map((therapy) => (
                    <button
                      key={therapy.id}
                      onClick={() => handleTherapyToggle(therapy.id)}
                      style={{
                        padding: '16px',
                        textAlign: 'left',
                        borderRadius: '8px',
                        border: formData.selectedTherapies.includes(therapy.id) ? '2px solid var(--teal)' : '1px solid #ddd',
                        background: formData.selectedTherapies.includes(therapy.id) ? 'var(--brand-primary-light)' : 'white',
                        cursor: 'pointer',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <input
                          type="checkbox"
                          checked={formData.selectedTherapies.includes(therapy.id)}
                          onChange={() => {}}
                          style={{
                            width: '18px',
                            height: '18px',
                            cursor: 'pointer',
                          }}
                        />
                        <div>
                          <div style={{ fontWeight: '600', fontSize: '16px', color: '#1a1a1a' }}>
                            {therapy.label}
                          </div>
                          <div style={{ fontSize: '13px', color: '#666' }}>
                            {therapy.stage}
                          </div>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={handleBack}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'white',
                      color: 'var(--teal)',
                      border: '1px solid var(--teal)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNext}
                    disabled={loading}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: 'var(--teal)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      opacity: loading ? 0.6 : 1,
                    }}
                  >
                    {loading ? 'Creating Account...' : 'Create Account'}
                  </button>
                </div>
              </>
            )}
          </form>
        ) : (
          /* Login Form */
          forgotMode ? (
            <form onSubmit={(e) => e.preventDefault()} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', justifyContent: 'center' }}>
                <button
                  type="button"
                  onClick={() => {
                    setForgotType('password');
                    setError('');
                    setResetStep('request');
                  }}
                  style={{
                    border: '1px solid #ddd',
                    background: forgotType === 'password' ? 'var(--brand-primary-light)' : 'white',
                    color: 'var(--teal)',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Password
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setForgotType('username');
                    setError('');
                  }}
                  style={{
                    border: '1px solid #ddd',
                    background: forgotType === 'username' ? 'var(--brand-primary-light)' : 'white',
                    color: 'var(--teal)',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Username
                </button>
              </div>
              <input
                type="email"
                name="resetEmail"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                required
                placeholder="Email"
                style={{
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                }}
              />

              {forgotType === 'password' && resetStep === 'confirm' && (
                <>
                  <input
                    type="text"
                    name="resetCode"
                    value={resetCode}
                    onChange={(e) => setResetCode(e.target.value)}
                    required
                    placeholder="Enter reset code"
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                  <input
                    type="password"
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    placeholder="New password"
                    style={{
                      padding: '12px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                    }}
                  />
                </>
              )}

              <button
                onClick={
                  forgotType === 'username'
                    ? handleRequestUsername
                    : resetStep === 'request'
                    ? handleRequestPasswordReset
                    : handleResetPassword
                }
                disabled={loading}
                style={{
                  padding: '12px',
                  marginTop: '8px',
                  background: 'var(--teal)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1,
                }}
              >
                {loading
                  ? 'Sending...'
                  : forgotType === 'username'
                  ? 'Send Username'
                  : resetStep === 'request'
                  ? 'Send Reset Code'
                  : 'Reset Password'}
              </button>

              {forgotType === 'password' && resetStep === 'request' && (
                <button
                  type="button"
                  onClick={() => setResetStep('confirm')}
                  style={{
                    marginTop: '8px',
                    background: 'none',
                    border: 'none',
                    color: 'var(--teal)',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '14px',
                  }}
                >
                  I already have a reset code
                </button>
              )}

              <button
                type="button"
                onClick={() => {
                  setForgotMode(false);
                  setForgotType('password');
                  setResetStep('request');
                  setError('');
                }}
                style={{
                  marginTop: '8px',
                  background: 'none',
                  border: 'none',
                  color: 'var(--teal)',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontSize: '14px',
                }}
              >
                Back to Sign In
              </button>
            </form>
          ) : (
            <form onSubmit={handleLoginSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                placeholder="Username"
                style={{
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                }}
              />
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Password"
                style={{
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                }}
              />
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '12px',
                  marginTop: '8px',
                  background: 'var(--teal)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1,
                }}
              >
                {loading ? 'Signing In...' : 'Sign In'}
              </button>
              <button
                type="button"
                onClick={handleGoogleSignIn}
                disabled={loading}
                style={{
                  padding: '12px',
                  background: 'white',
                  color: '#1a1a1a',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                }}
              >
                <span style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  background: 'var(--brand-primary-light)',
                  color: 'var(--teal)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: '700',
                }}>
                  G
                </span>
                Continue with Google
              </button>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                <button
                  type="button"
                  onClick={() => {
                    setForgotMode(true);
                    setForgotType('password');
                    setResetStep('request');
                    setError('');
                    setResetEmail(formData.email || '');
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--teal)',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '14px',
                    padding: 0,
                  }}
                >
                  Forgot password?
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setForgotMode(true);
                    setForgotType('username');
                    setError('');
                    setResetEmail(formData.email || '');
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--teal)',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '14px',
                    padding: 0,
                  }}
                >
                  Forgot username?
                </button>
              </div>
            </form>
          ))}

        {/* Toggle Between Login and Registration */}
        <div style={{
          marginTop: '20px',
          textAlign: 'center',
          fontSize: '14px',
          color: '#666',
        }}>
          {isRegistering ? 'Already have an account?' : "Don't have an account?"}{' '}
          <button
            onClick={() => {
              setIsRegistering(!isRegistering);
              setRegistrationStep('account');
              setError('');
              setFormData({
                username: '',
                password: '',
                name: '',
                dateOfBirth: '',
                email: '',
                role: '',
                currentSituation: '',
                cancerType: '',
                diseaseStage: '',
                selectedTherapies: [],
              });
              setCancerSearch('');
            }}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--teal)',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              textDecoration: 'underline',
            }}
          >
            {isRegistering ? 'Sign in' : 'Sign up'}
          </button>
        </div>
      </div>
    </div>
  );
}
